import { ordersConstants } from "../actions/types";
const initialState = {
    orders: [],
    searchedOrders: [],
    currentOrder: null,
    loadingOrders: false,
    totalOrders: 0,
    currentPage: 1,
    pageSize: 10,
};
export const ordersReducer = (state = initialState, action) => {
    const { type, payload } = action;
    switch (type) {
        case ordersConstants.SET_ORDERS:
            return Object.assign(Object.assign({}, state), { orders: payload });
        case ordersConstants.SET_SEARCHED_ORDERS:
            return Object.assign(Object.assign({}, state), { searchedOrders: payload });
        case ordersConstants.SET_CURRENT_ORDER:
            return Object.assign(Object.assign({}, state), { currentOrder: payload });
        case ordersConstants.ADD_ORDER:
            return Object.assign(Object.assign({}, state), { orders: [payload, ...state.orders] });
        case ordersConstants.UPDATE_ORDER:
            return Object.assign(Object.assign({}, state), { orders: state.orders.map((order) => order._id === payload._id ? payload : order) });
        case ordersConstants.DELETE_ORDER:
            return Object.assign(Object.assign({}, state), { orders: state.orders.filter((order) => order._id !== payload._id) });
        case ordersConstants.SET_LOADING_ORDERS:
            return Object.assign(Object.assign({}, state), { loadingOrders: payload });
        case ordersConstants.SET_TOTAL_ORDERS:
            return Object.assign(Object.assign({}, state), { totalOrders: payload });
        case ordersConstants.SET_CURRENT_PAGE:
            return Object.assign(Object.assign({}, state), { currentPage: payload });
        case ordersConstants.SET_PAGE_SIZE:
            return Object.assign(Object.assign({}, state), { pageSize: payload });
        default:
            return state;
    }
};
